import styled from 'styled-components'
import { Button } from '@dsny/dsny-component-library'

export const TrackSearchCardContainer = styled.div`
  padding: 16px 24px;
  border-radius: 5px;
  background-color: transparent;
  max-width: 214px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutralW20};

    img {
      opacity: 0.5;
      background: ${({ theme }) => theme.colors.black0};
    }

    .action_bar {
      visibility: visible;
      opacity: 1;
    }
  }
`

export const ImageContainer = styled.div`
  position: relative;
  width: 160px;
  height: 160px;
  margin-bottom: 8px;
`

export const TrackSearchCardImage = styled.img`
  border-radius: 5px;
  object-fit: cover;
  width: 100%;
  height: 100%;
  transition: opacity 0.2s ease;
`

export const ActionBarAbsoluteContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 64px;
  padding-bottom: 10px;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s ease;
`

export const ActionBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 100%;
`

export const ActionButton = styled(Button)`
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.neutralW50 : theme.colors.neutralW100};
  color: ${({ theme }) => theme.colors.neutralW20};
  padding: 0;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  border: none;

  &:hover {
    background-color: ${({ theme, disabled }) =>
      disabled ? theme.colors.neutralW50 : theme.colors.neutralW80};
  }
`

export const TextContainer = styled.div`
  width: 160px;
  text-align: center;
`
